export default __webpack_public_path__ + "static/media/pay_at_machine.2de8056f.png";